<template>
  <div id="container" ref="mapRef" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <nyTit pathUrl='/qihouYj' />
    <div class="container">
      <!-- 标题 -->
      <!-- <div class="biaoti"></div> -->

      <!-- <div class="fc"></div> -->
      <!--      第一个-->
      <div class="left_txt margin-top">
        <div class="l_t_top">
          <div class="t_bt">
            <h5>种植模型数据采集</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="t_down">
            <div class="t_d_t">
              <div class="t_d_t_jz">
                <span></span>
                <h6>选择区域：</h6>
                <div class="srk">河南省驻马店市上蔡县</div>
              </div>
            </div>
            <div class="t_d_b">
              <div class="t_d_t_jz">
                <span></span>
                <h6>选择分类：</h6>
                <div class="srk">小麦</div>
              </div>
            </div>
            <div class="t_d_d">
              <div class="t_d_t_jz">
                <span></span>
                <h6>选择品类：</h6>
                <div class="srk">淮麦32</div>
              </div>
            </div>
            <div class="t_d_d1">
              <div class="t_d_d1_l">
                <h5>地块管理</h5>
                <div class="d1_xtb"></div>
              </div>
              <div class="t_d_d1_r" @click="clickFangan(0)">
                <h5>生成方案</h5>
                <div class="d1_xtb"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="l_t_down">
          <div class="t_bt">
            <h5>种植数据方案</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="l_t_d_m">
            <div
              class="l_t_d_m_g"
              :class="{ l_t_d_m_g_cur: leftData1Cur == index }"
              v-for="(item, index) in leftDatas1"
              :key="index"
              @click="leftTab1(index)"
            >
              {{ item.name }}
            </div>
            <!-- <div class="l_t_d_m_g">生长记录</div>
          <div class="l_t_d_m_g">种植方案</div> -->
          </div>
          <div class="scrollTable">
            <dv-scroll-board
              :config="leftDatas1[leftData1Cur].config"
              style="width: 100%; height: 100%"
            />
          </div>
        </div>
      </div>
      <!--     第二个-->
      <div class="left_txt_2 margin-top">
        <div class="left_txt_2_top">
          <div class="t_bt">
            <h5>作物发育曲线</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="di2_txt">
            <leftLine />
          </div>
        </div>
        <div class="left_txt_2_down">
          <div class="t_bt">
            <h5>土壤水量胁迫分析</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="di2_txt">
            <leftBars :leftData1="leftData1" />
          </div>
        </div>
      </div>
      <!--     第3个-->
      <div class="right_txt margin-top">
        <div class="right_txt_top">
          <div class="xm_bg">
            <dv-border-box-8 :dur="4" :reverse="true">
              <img :src="plant[curLeftIndex].img" />
            </dv-border-box-8>
          </div>
          <div class="kqwd" :style="{ transform: `translateY(${offset}px)` }">
            <span class="f_g_bg"></span>
            <span></span>
            <h6>20℃</h6>
            <h5>空气温度</h5>
          </div>
          <div class="trsd" :style="{ transform: `translateY(${offset1}px)` }">
            <span class="f_g_bg"></span>
            <span></span>
            <h6>88%</h6>
            <h5>土壤湿度</h5>
          </div>
          <div class="gzqd" :style="{ transform: `translateY(${offset2}px)` }">
            <span class="f_g_bg"></span>
            <span></span>
            <h6>5klux</h6>
            <h5>光照强度</h5>
          </div>
          <div class="fs" :style="{ transform: `translateY(${offset}px)` }">
            <span class="f_g_bg"></span>
            <span></span>
            <h6>7m/s</h6>
            <h5>风速</h5>
          </div>
          <div class="jyl" :style="{ transform: `translateY(${offset3}px)` }">
            <span class="f_g_bg"></span>
            <span></span>
            <h6>1mm</h6>
            <h5>降雨量</h5>
          </div>
          <div class="trwd" :style="{ transform: `translateY(${offset2}px)` }">
            <span class="f_g_bg"></span>
            <span></span>
            <h6>20℃</h6>
            <h5>土壤温度</h5>
          </div>
        </div>
        <div class="plant">
          <el-tabs
            v-model="activeName"
            class="demo-tabs"
            @tab-click="handleClick"
            id="tabs"
          >
            <el-tab-pane
              v-for="(item, index) in plant"
              :key="index"
              :label="item.name"
              :name="index"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="di_bu_dh"><nyNav /></div>
      </div>
      <!--     第4个-->
      <div class="right_txt_1 margin-top">
        <div class="right_txt_1_top">
          <div class="t_bt">
            <h5>温度胁迫生长发育曲线</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="di2_txt">
            <righttBar />
          </div>
        </div>
        <div class="right_txt_1_down">
          <div class="t_bt">
            <h5>种植模型数据采集</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="di2_txt">
            <righttBars />
            <!-- <leftBars :leftData1="leftData1" /> -->
          </div>
        </div>
      </div>
      <!--     第5个-->
      <div class="right_txt_2 margin-top">
        <div class="right_txt_2_top">
          <div class="t_bt">
            <h5>种植模型数据采集</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="di2_txt">
            <div class="di2_txt_left" @click="clickFangan(1)">
              <img src="../assets/img/plantmoxing/new/jl.png" />
              <h4>模型结论</h4>
            </div>
            <div class="di2_txt_left">
              <img src="../assets/img/plantmoxing/new/zj.png" />
              <h4>专家建议</h4>
            </div>
          </div>
        </div>
        <div class="right_txt_2_down">
          <div class="t_bt">
            <h5>固定式喷灌区</h5>
            <span></span>
            <span class="gs"></span>
          </div>
          <div class="di2_txt">
            <div class="di3_txt">
              <div
                class="guding_peng_g"
                v-for="(item, index) in ggdata"
                :key="index"
                @click="videoClick(index)"
              >
                <img :src="item.img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 方案 -->
  <div class="popBg animate__animated animate__zoomIn" @click.stop="hiddlen" v-if="faSHow">
    <div class="faCon" @click.stop="hiddlen1">
      <div class="close" @click.stop="hiddlen">×</div>
      <div class="faInfo">
        <dv-scroll-board :config="config" style="width: 100%; height: 100%" v-if="popType==0" />
        <div class="moxing" v-else>
          <h2>模型结论</h2>
          <div>
            <h3>模型结论</h3>
            <p>小麦的生长期需要根据播种的时间而定，通常小麦从播种到成熟，生长周期在220~270天左右，再加上各地的天气情况都有所不同，因此小麦具体要生长多久需要根据实际情况而定。</p>
          </div>
          <div>
            <h3>专家建议</h3>
            <p class="ql-align-justify">一、选择适宜的种植时间<br>
              小麦适宜在10月中旬至11月初的时间内进行种植。选择土地肥沃、放耕时间长的地块，同时保证充足的阳光、空气和水分。<br>
              <br>
              二、合理使用施肥<br>
              在小麦的生长过程中，应当加强肥料的施用，尤其是氮肥。要注意在小麦中后期进行补充肥料，加强磷、钾元素的供应。同时在使用肥料时要保证控制施肥量，避免“过肥”。<br>
              <br>
              三、做好病虫害防治工作<br>
              小麦的生长期中，常常会遇到干旱、水浸、冻害等灾害，同时也会受到病虫害的威胁。因此，在种植小麦时，要加强病虫害的防治。可以采取喷药、轮作等措施来避免病虫害对小麦的危害。<br>
              <br>
              四、注意细节，提高产量<br>
              在小麦的生长过程中，还需要注意以下几点：<br>
              1. 种植密度应适中，过于密集或过于稀疏都会影响小麦的生长和产量。<br>
              2. 及时除草，保证土壤通透性和水分透过性。<br>
              3. 控制小麦的生长高度，避免过长或过短。<br>
              4. 在小麦成熟后及时收割，防止小麦散粒。</p>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- 弹出视频 -->
  <popBg
    :title="videoList[curVideoIndex].name"
    style="z-index: 99999"
    :popShow="popShow"
    @hiddlen="popHiddlen"
  >
    <vue3VideoPlay
      id="video"
      width="100%"
      height="100%"
      title="冰河世纪"
      :src="videoList[curVideoIndex].options.src"
      :type="videoList[curVideoIndex].options.type"
      :autoPlay="true"
    />
  </popBg>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";

// todo 项目使用请放开 leaflet 引入

// import * as L from 'leaflet/dist/leaflet.esm.js';
import nyNav from "../components/nyNav.vue";
import nyTit from "../components/nyTit.vue";
import footer1 from "../components/footer.vue";
import leftBars from "../components/plantmoxing/leftBar1.vue";
import leftLine from "../components/plantmoxing/leftLine.vue";
import righttBar from "../components/plantmoxing/righttBar.vue";
import righttBars from "../components/plantmoxing/righttBars.vue";
import popBg from "../components/popBg.vue";
export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();

    const state = reactive({
      videoList: [
        {
          name: "固定式喷灌区",
          options: {
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/8.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "固定式喷灌区",
          options: {
            src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/9.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
      ],
      curVideoIndex: 0,
      popShow: false,
      leftDatas1: [
        {
          name: "生长记录",
          config: {
            header: [
              '<span style="color:#fff;">农情</span>',
              '<span style="color:#fff;">项目</span>',
              '<span style="color:#fff;">记录</span>',
            ],

            data: [
              ["10-17", "播种环节农机服务", "灭茬45元/亩/次 1次 撒有机肥35元/亩/次 1次  深耕40元/亩/次 1次  旋地35元/亩/次 2次   种肥同播50元/亩/次 1次  震压10元/亩/次  1次"],
              ["10-21", "施肥", "羊粪700元/吨 400-600斤/亩 澳佳微生物肥 2500元/吨 70kg/亩  ETS菌肥1158元/吨 澳佳13-18-15 t3950元/吨 t120斤/亩 骏华25-13-7 3850元/吨 100斤/亩 鲁西15-15-15 3980元/吨 100斤/亩"],
              ["10-21", "播种", "天宁38 3.6元/斤 40斤/亩 新麦45 3.6元"],
              ["11-05", "蒙头水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],
              ["02-04", "越冬水灌溉", "骏华第十六元素\\t2850元/吨\\t30斤/亩\\n澳佳乌金氮\\t3050元/吨\\t30斤/亩\\n播肥机\\t12元/亩\\t1次"],
              ["02-27", "打药", "\"药品1：美丰麦笑（双氟·氯氟吡）+锐耙（2甲4氯钠）+亨达超克（联苯·噻虫嗪）\n" +
              "药品2：酷佬（2甲·双氟·唑）+闪净（联菊·啶虫脒）+恋神奇（碳机硅）\"\n" +
              "多花黑麦草除草剂：美丰瑞丰年（20%甲基二磺隆·异丙隆）+美丰无止境（哗咻草醋）\n" +
              "除草剂、杀虫剂\t12元/亩\t1次\n" +
              "机械\t8元/亩\t\n" +
              "多花黑麦草\t50元/亩\t1次\n" +
              "机械\t8元/亩\t"],
              ["03-09", "打药", "\"药品1：利尔作物·独功（氯氟·毒死蜱）+乐奥多·微量元素水溶肥料+利尔作物·普伴（24-表芸苔素内脂）+赛都优（氨基寡糖素）\n" +
              "药品2：六夫丁·快守（高效氯氟氰菊酯）+澳佳·活力丰（腐殖酸钾）+佳运（24-表芸苔素内脂）+优植康·清辞（寡糖·吗胍）\"\n" +
              "一喷三防\t18元/亩/次\t1次"],
              ["03-14", "返青水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],

            ],
            headerBGC: "#274547",
            oddRowBGC: "",
            evenRowBGC: "",
            index: false,
            columnWidth: [200, 200],
            align: ["center", "left", "left"],
            // rowNum:6
          },
        },
        {
          name: "种植方案",
          config: {
            header: [
              '<span style="color:#fff;">日期</span>',
              '<span style="color:#fff;">农事</span>',
              '<span style="color:#fff;">具体操作</span>',
            ],
            data: [
              ["6-21", "追肥", "施用叶面肥1683亩"],
              ["7-21", "化控", "植保无人机一喷三防共3493亩"],
              ["8-01", "收获", "收获1452亩"],
              ["9-21", "追肥", "施用复合肥426亩"],
              ["11-21", "底肥撒施", "施用复合肥1118亩"],
              ["11-26", "追肥", "施用叶面肥1683亩"],
              ["11-30", "化控", "植保无人机一喷三防共3493亩"],
              ["12-21", "收获", "收获1452亩"],
              ["12-21", "追肥", "施用复合肥426亩"],
              ["12-21", "底肥撒施", "施用复合肥1118亩"],
            ],
            headerBGC: "#274547",
            oddRowBGC: "",
            evenRowBGC: "",
            index: false,
            // columnWidth: [100, 100],
            align: ["center", "center", "left"],
            // rowNum:6
          },
        },
      ],
      leftData1Cur: 0,
      leftData1: [
        ["第一季度", "第二季度", "第三季度", "第四季度"],
        [70, 30, 100, 10],
      ],

      ggdata: [
        {
          name: "备播期",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/8.png",
        },
        {
          name: "播种期",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/9.png",
        },
      ],
      plant: [
        {
          name: "备播期",
          img: require("@/assets/img/plantmoxing/bbq.png"),
        },
        {
          name: "播种期",
          img: require("@/assets/img/plantmoxing/new/2.webp"),
        },
        {
          name: "岀苗期",
          img: require("@/assets/img/plantmoxing/new/3.jpeg"),
        },
        {
          name: "分蘖期",
          img: require("@/assets/img/plantmoxing/new/4.webp"),
        },
        {
          name: "越冬期",
          img: require("@/assets/img/plantmoxing/new/5.jpeg"),
        },
        {
          name: "返靑期",
          img: require("@/assets/img/plantmoxing/new/6.png"),
        },
        {
          name: "起身期",
          img: require("@/assets/img/plantmoxing/new/7.webp"),
        },
        {
          name: "拔节期",
          img: require("@/assets/img/plantmoxing/new/8.png"),
        },
        {
          name: "抽穗期",
          img: require("@/assets/img/plantmoxing/new/9.webp"),
        },
        {
          name: "开花期",
          img: require("@/assets/img/plantmoxing/new/10.jpeg"),
        },
        {
          name: "灌浆期",
          img: require("@/assets/img/plantmoxing/new/11.png"),
        },
        {
          name: "成孰期",
          img: require("@/assets/img/plantmoxing/new/12.webp"),
        },
        {
          name: "收获期",
          img: require("@/assets/img/plantmoxing/new/13.png"),
        },
      ],

      curLeftIndex: 0,
      offset: 0,
      direction: 1, // 1表示向下移动，-1表示向上移动
      speed: 1, // 移动速度
      offset1: 0,
      direction1: 1, // 1表示向下移动，-1表示向上移动
      speed1: 1.2, // 移动速度
      offset2: 0,
      direction2: 1, // 1表示向下移动，-1表示向上移动
      speed2: 1.4, // 移动速度
      offset3: 0,
      direction3: 1, // 1表示向下移动，-1表示向上移动
      speed3: 1.5, // 移动速度
      config: {
        header: [
          '<span style="color:#fff;">农情</span>',
          '<span style="color:#fff;">项目</span>',
          '<span style="color:#fff;">记录</span>',
        ],

        data: [
          [
            "10-25",
            "物资准备",
            "物资准备",
          ],
          [
            "10-26",
            "精细整地",
            "施肥、犁地、旋地",
          ],
          [
            "10-27",
            "底肥撒施",
            "尿素:8.7kg/亩;二铵:10.0kg/亩;硫酸钾:2.6kg/亩或尿素:8.7kg/亩;二铵:10.0kg/亩;氯化钾:2.4kg/亩",
          ],
          [
            "11-15",
            "播种",
            "用穴播机播种，机具运行速度要中等匀速，行间距保持一致，确保每穴下籽量基本相同，每亩地播种30斤左右小麦种子",
          ],
          ["11-15", "补苗 ", "如遇到小麦出苗率低的地方，建议补苗。"],
          [
            "03-05",
            "苗后除草",
            "化学除草宜选择在小麦3~5期、杂草2~4叶期、日平均气温在6℃以上的晴天进行，可选用甲基二磺隆防除节节麦、蔄草、硬草，选用啶磺草胺氟唑磺隆防除雀麦，选用唑啉草酯、炔草酯防除野燕麦、日本看麦娘、看麦娘，选用双氟磺草胺、2甲4钠、氟氧乙酸唑草酮或双唑草酮防除播娘蒿、猪殃殃、婆婆纳、牛繁缕等阔叶杂草。",
          ],
          ["03-05", "浇水", "看土地墒情"],
          [
            "04-15",
            "打药",
            "抽穗扬花期，这个时期小麦处于见花打药的状态。以预防小麦赤霉病为主，兼顾条锈病、白粉病、蚜虫以及其他咀嚼式害虫。防治药剂：可选用氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（啶虫脒、吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素、赤·吲乙·芸苔）。可合理选用叶面肥（植物动力2003、保势腾、美座），混合喷施。",
          ],
          [
            "05-05",
            "打药",
            "灌浆成熟期，这个时期小麦处于抽穗至灌浆期，重点防控小麦穗蚜、条锈病，预防赤霉病，预防干热风、抗旱、抗倒伏，兼顾其他咀嚼式害虫。防治药剂：可选用氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素内酯）。可合理添加叶面肥（植物动力2003、保势腾、美座）喷施，实现“一喷多防”。",
          ],
          [
            "06-01",
            "收获 ",
            "810公斤/亩，小麦成熟，收割入仓。",
          ],
        ],
        headerBGC: "#15364D",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        columnWidth: [200, 200],
        align: ["center", "center", "left"],
        rowNum: 12,

      },
      activeName: 0,
      faSHow: false,
      popType:0
    });

    // 在 onMounted 中初始化地图
    onMounted(() => {
      animate();
    });
    // 关闭生成方案
    function hiddlen() {
      state.faSHow = false;
    }
    // 生成方案
    function clickFangan(type) {
      state.faSHow = true;
      state.popType = type
    }
    // 左侧切换
    function leftTab1(index) {
      state.leftData1Cur = index;
    }
    function animate() {
      setInterval(() => {
        state.offset += state.direction * state.speed;
        state.offset1 += state.direction1 * state.speed1;
        state.offset2 += state.direction2 * state.speed2;
        state.offset3 += state.direction3 * state.speed3;

        // 当移动到边界时反转方向
        if (state.offset >= 16 || state.offset <= -16) {
          state.direction *= -1;
        }
        if (state.offset1 >= 15 || state.offset1 <= -15) {
          state.direction1 *= -1;
        }
        if (state.offset2 >= 14 || state.offset2 <= -14) {
          state.direction2 *= -1;
        }
        if (state.offset3 >= 16 || state.offset3 <= -16) {
          state.direction3 *= -1;
        }

        // Vue3中不需要$forceUpdate，因为响应式系统会自动更新视图
      }, 100); // 动画速度根据实际情况调整（这里是每100毫秒执行一次）
    }

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    function handleClick(tab, e) {
      // console.log(tab.index)
      state.curLeftIndex = tab.index;
      console.log(state.curLeftIndex);
    }

    // 弹出视频
    function videoClick(index) {
      console.log(index);
      state.popShow = true;
      state.curVideoIndex = index;
    }
    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }
    onUnmounted(() => {});
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      leftTab1,
      clickReturn,
      handleClick,
      clickFangan,
      hiddlen,
      videoClick,
      popHiddlen,
    };
  },
  components: {
    footer1,
    leftBars,
    leftLine,
    nyNav,
    nyTit,
    righttBar,
    righttBars,
    popBg,
  },
};
</script>
<style lang="less" scoped>
// 方案
.popBg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all 0.5s ease-out;
  .faCon {
    width: 50%;
    height: 70%;
    position: absolute;
    top: 15%;
    left: 25%;
    background: #102130;
    // border: 2px solid;
    border: 2px solid #16616a;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 50px;
    box-sizing: border-box;
    align-items: center;
    overflow-y: auto;
    .close {
      color: rgba(255, 255, 255, 0.8);
      font-size: 60px;
      position: absolute;
      top: 20px;
      right: 26px;
      cursor: pointer;
    }
    .faInfo {
      width: 90%;
      flex: 1;
      margin-top: 30px;
      font-size: 14px;
      .moxing{
        line-height: 50px;
        line-height: 52px;
        h2{
          font-size: 40px;
          color: #0CB3A5;
        }
        h3{
          font-size: 36px;
          color: #0CB3A5;
          text-align: left;
          margin: 10px 0;
        }
        p{
          text-align: left;
          font-size: 30px;
          color: rgba(255,255,255,.8);
        }
      }
    }
  }
}
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .el-tabs__item {
  width: 147px;
  height: 160px;
  padding: 0;
  // border: 1px solid #1a6266;
  display: flex;
  justify-content: center;
  font-size: 30px;
  line-height: 80px;
  align-items: self-start;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before,
::v-deep .el-tabs__item::after {
  content: " ";
  background: #21fcff;
  width: 2px;
  height: 12px;
  position: absolute;
  top: 12px;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before {
  left: -1px;
}
::v-deep .el-tabs__item::after {
  right: -1px;
}
::v-deep .el-tabs__nav {
  display: flex;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__active-bar {
  width: 100%;
  background-color: #21fcff;
}
::v-deep .is-active {
  color: #a1c81f;
}
::v-deep .el-tabs__nav-prev {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt.png") no-repeat top center;
  background-size: 100% 100%;
  width: 72px;
  height:92px;
  left: 1px;
  top: -2px;

  color: transparent; /* 文字颜色透明 */
}
::v-deep .el-tabs__nav-prev:hover {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt1.png") no-repeat top center;
  background-size: 100% 100%;
  width: 72px;
  height: 92px;
  left: -4px;
  top: -2px;

  color: transparent; /* 文字颜色透明 */
}
::v-deep .el-tabs__nav-next {
  background: url("../assets/img/plantmoxing/zjt.png") no-repeat top center;
  background-size: 100% 100%;
  width: 72px;
  height: 92px;
  right: 1px;
  top: -2px;
  transform: scaleX(-1);
  color: transparent; /* 文字颜色透明 */
}
::v-deep .el-tabs__nav-next:hover {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt1.png") no-repeat top center;
  background-size: 100% 100%;
  width: 72px;
  height: 92px;
  right: 1px;
  top: -2px;
  transform: scaleX(-1);
  color: transparent; /* 文字颜色透明 */
}
::v-deep .dv-scroll-board .header {
  display: flex;
  flex-direction: row;
  font-size: 30px;
  background: url("../assets/img/plantmoxing/new/jb.png") no-repeat top center;
  background-size: 100% 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .dv-scroll-board .rows .row-item {
  font-size: 30px;
}
::v-deep .el-tabs__nav-wrap.is-scrollable{
  padding: 0 100px;
}
::v-deep .el-tabs__active-bar{
  bottom: 79px;
}
.container {
  width: 100%;
  height: 100%;
  display: flex;
  padding-bottom: 80px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  .containerBg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
  }
  .margin-top {
    height: calc(100% - 173px);

    margin-left: 57px;
    // border: 1px solid red;
  }
  .t_bt {
    width: 100%;
    height: 120px;
    position: relative;
    left: 0;
    h5 {
      width: 100%;
      height: 100%;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 800;
      font-size: 40px;
      color: #ffefd4;
      line-height: 71px;
      text-shadow: 3px 0px 13px #000000;
      text-align: center;
      font-style: normal;
      text-transform: none;
      background: radial-gradient(0deg, #fffbf2 60%, #f8da9b 100%);
    }
    span {
      width: 100%;
      height: 100%;
      background: url("../assets/img/plantmoxing/btk.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      line-height: 200%;
      top: 40px;
    }
    .gs {
      width: 150px;
      height: 20px;
      background: url("../assets/img/plantmoxing/gx.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: 424px;
      top: 69px;
      animation: left1Img 2s linear infinite;
    }
  }
  .left_txt {
    width: 16%;
    display: flex;
    flex-direction: column;
    z-index: 999;

    .l_t_top {
      width: 100%;
      height: 600px;
      // border: #3bf4be 1px solid;
      position: relative;

      .t_down {
        width: 100%;
        height: 510px;
        // border: #3bf4be 1px solid;
        display: flex;
        flex-direction: column;
        .t_d_t_jz {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;

          h6 {
            width: 180px;
            height: 78px;
            font-size: 30px;
            color: #fff;
            text-align: left;
            line-height: 78px;
            // position: absolute;
            // left: 40px;
            // top: 0;
            letter-spacing: 5px;
            margin-right: 20px;
          }
          .srk {
            width: 520px;
            height: 78px;
            background: url("../assets/img/plantmoxing/xzk.png") no-repeat top
              center;
            background-size: 100% 100%;
            // position: absolute;
            overflow: hidden;
            // right: 80px;
            // top: 0;
            font-size: 32px;
            color: #fff;
            line-height: 78px;
            text-align: left;
            letter-spacing: 4px;
            text-indent: 2em;
          }
        }

        .triangle {
          width: 0;
          height: 0;
          border-style: solid;
          position: absolute;
          border-width: 9px 9px 0 9px; /* 上下左右四个边框宽度 */
          border-color: #829297 transparent transparent transparent; /* 边框颜色：上红 下透明 左透明 右透明 */
          right: 110px;
          top: 22px;
          display: none;
        }

        .t_d_t {
          width: 100%;
          height: 78px;
          // margin: 20px 0;

          span {
            width: 28px;
            height: 32px;
            background: url("../assets/img/plantmoxing/qy.png") no-repeat top
              center;
            background-size: 100% 100%;

            font-size: 30px;

            margin-right: 20px;
          }
        }
        .t_d_b {
          width: 100%;
          height: 78px;
          margin: 30px 0;

          span {
            width: 28px;
            height: 32px;
            background: url("../assets/img/plantmoxing/pl.png") no-repeat top
              center;

            font-size: 30px;
            margin-right: 20px;
          }
        }
        .t_d_d {
          width: 100%;
          height: 78px;
          margin: 10px 0;
          position: relative;
          span {
            width: 28px;
            height: 32px;
            background: url("../assets/img/plantmoxing/pz.png") no-repeat top
              center;
            background-size: 100% 100%;
            margin-right: 20px;
          }
        }
        .t_d_d1 {
          width: 100%;
          height: 80px;
          margin-top: 35px;
          // position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          h5 {
            width: 160px;
            height: 80px;
            font-size: 30px;
            color: #fff;
            text-align: left;
            line-height: 80px;
            letter-spacing: 4px;
            margin-right: 40px;
            margin-left: 0;
          }

          .t_d_d1_l {
            width: 290px;
            height: 100%;
            margin-right: 20px;
            background: url("../assets/img/plantmoxing/new/dk.png") no-repeat
              top center;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            // position: absolute;
            // left: 73px;
            .d1_xtb {
              width: 26px;
              height: 26px;
              background: url("../assets/img/plantmoxing/dkgl.png") no-repeat
                top center;
              background-size: 100% 100%;
              // position: absolute;
              // right: 22px;
              // top: 10.5px;
            }
          }
          .t_d_d1_r {
            width: 290px;
            height: 100%;
            background: url("../assets/img/plantmoxing/new/dk.png") no-repeat
              top center;
            background-size: 100% 100%;
            display: flex;
            margin-left: 20px;
            justify-content: center;
            align-items: center;
            // position: absolute;
            // right: 80px;
            cursor: pointer;
            .d1_xtb {
              width: 26px;
              height: 26px;
              background: url("../assets/img/plantmoxing/scfa.png") no-repeat
                top center;
              background-size: 100% 100%;
              // position: absolute;
              // right: 22px;
              // top: 10.5px;
            }
          }
        }
      }
    }
    .l_t_down {
      // border: #3bf4be 1px solid;
      flex: 1;
      .l_t_d_m {
        width: 100%;
        height: 75px;
        position: relative;
        top: -25px;
        left: 0;
        display: flex;
        justify-content: center;
        .l_t_d_m_g {
          width: 150px;
          height: 75px;
          font-size: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #01e9e7;
          background: url("../assets/img/plantmoxing/szjl.png") no-repeat top
            center;
          background-size: 100% 100%;
          cursor: pointer;
          margin: 5px 50px 0;
        }
        .l_t_d_m_g_cur {
          color: #a1c81f;
        }

        // .l_t_d_m_l {
        //   left: 166px;
        // }
        // .l_t_d_m_r {
        //   right: 166px;
        // }
      }
      .scrollTable {
        width: 100%;
        height: 70%;
        // border: #fff 1px solid;
      }
    }
  }

  .left_txt_2 {
    width: 16%;
    display: flex;
    flex-direction: column;
  }
  .di2_txt {
    flex: 1;
  }
  .left_txt_2_top {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .left_txt_2_down {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .right_txt_1_top {
    width: 100%;
    height: 40%;
    display: flex;
    flex-direction: column;
  }
  .right_txt_1_down {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .right_txt {
    flex: 1;
    // border: #01e9e7 1px solid;
    position: relative;
    display: flex;
    flex-direction: column;
    .right_txt_top {
      width: 100%;
      flex: 1;

      // border: #fff 1px solid;
      background: url("../assets/img/plantmoxing/lt.png") no-repeat top center;
      background-size: 100% 100%;
      // position: absolute;
      display: flex;
      // align-items: center;
      justify-content: center;
      margin-top: 90px;
      .xm_bg {
        width: 1220px;
        height: 660px;
        background: url(/img/tpk.f80a61e5.png) no-repeat top center;
        background-size: 100% 100%;
        // margin-top: 30px;
        // position: absolute;
        // top: 18%;
        // left: 25%;

        img {
          width: 100%;
          height: 100%;
          padding: 20px 20px;
        }
      }
      .kqwd {
        width: 192px;
        height: 209px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: -4%;
        top: 130px;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;

          animation: left1Img 2s linear infinite;
        }
        span {
          width: 39px;
          height: 41px;
          background: url("../assets/img/plantmoxing/kq.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin-top: 5px;
        }
        h6 {
          width: 100%;
          font-size: 30px;

          color: #02f6e3;

          margin: 5px 0;
        }
        h5 {
          width: 100%;
          font-size: 30px;
          // height: 25px;
          // line-height: 25px;
          color: #02f6e3;
          // position: absolute;
          // top: 49px;
        }
      }
      .trsd {
        width: 223px;
        height: 243px;
        background: url("../assets/img/plantmoxing/dk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 8%;
        top: 45px;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        .f_g_bg {
          width: 72px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;

          animation: left1Img 2s linear infinite;
        }

        span {
          width: 43px;
          height: 43px;
          background: url("../assets/img/plantmoxing/tr.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin-top: 5px;
        }
        h6 {
          width: 100%;
          font-size: 30px;
          color: #02f6e3;
          margin: 5px 0;
        }
        h5 {
          width: 100%;
          font-size: 30px;
          color: #02f6e3;
        }
      }
      .gzqd {
        width: 192px;
        height: 209px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: 35%;
        left: 5%;
        position: absolute;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        .f_g_bg {
          width: 72px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          // position: absolute;
          // top: -3px;
          // left: 19px;
          animation: left1Img 2s linear infinite;
        }
        span {
          width: 39px;
          height: 41px;
          background: url("../assets/img/plantmoxing/gz.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin-top: 5px;
        }
        h6 {
          width: 100%;
          font-size: 30px;
          color: #02f6e3;
          margin: 5px 0;
        }
        h5 {
          width: 100%;
          font-size: 30px;
          color: #02f6e3;
        }
      }
      .fs {
        width: 223px;
        height: 243px;
        background: url("../assets/img/plantmoxing/dk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: 4%;
        left: 80%;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        .f_g_bg {
          width: 72px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;

          animation: left1Img 2s linear infinite;
        }
        span {
          width: 43px;
          height: 43px;
          background: url("../assets/img/plantmoxing/fs.png") no-repeat top
            center;
          background-size: 100% 100%;
        }
        h6 {
          width: 100%;
          font-size: 30px;
          margin: 5px 0;
          color: #02f6e3;
        }
        h5 {
          width: 100%;
          font-size: 30px;
          color: #02f6e3;
        }
      }
      .jyl {
        width: 192px;
        height: 209px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: 10%;
        left: 94%;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        .f_g_bg {
          width: 72px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          animation: left1Img 2s linear infinite;
        }
        span {
          width: 39px;
          height: 41px;
          background: url("../assets/img/plantmoxing/jyl.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin-top: 5px;
        }
        h6 {
          width: 100%;
          font-size: 30px;

          color: #02f6e3;
          margin: 5px 0;
        }
        h5 {
          width: 100%;
          font-size: 30px;
          color: #02f6e3;
        }
      }
      .trwd {
        width: 192px;
        height: 209px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: 33%;
        left: 86%;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;

          animation: left1Img 2s linear infinite;
        }
        span {
          width: 39px;
          height: 41px;
          background: url("../assets/img/plantmoxing/wd.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin-top: 5px;
        }
        h6 {
          width: 100%;
          font-size: 30px;
          margin: 5px 0;
          color: #02f6e3;
        }
        h5 {
          width: 100%;
          font-size: 30px;

          color: #02f6e3;
        }
      }
    }
    .plant {
      width: 100%;
      height: 160px;
      position: absolute;
      // border: 1px salmon solid;
      left: 0;
      bottom: 18%;
    }
    .di_bu_dh {
      width: 100%;
      height: 240px;
      padding: 20px 25px;
    }
  }
  .right_txt_1 {
    width: 16%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .right_txt_2 {
    width: 16%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
  }
  .right_txt_2_top {
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    .di2_txt {
      display: flex;
      align-items: center;
      justify-content: center;
      .di2_txt_left {
        width: 327px;
        height: 145px;
        background: url("../assets/img/plantmoxing/new/mxk.png") no-repeat top
          center;
        background-size: 100% 100%;
        margin: 5px 50px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        img {
          width: 40px;
          height: 40px;
          margin: 0 0 5px 48px;
        }
        h4 {
          font-size: 30px;
          color: #fff;
          margin: 10px 0 5px 48px;
        }
      }
    }
  }
  .right_txt_2_down {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    //margin-top: 40px;
    .di2_txt {
      .di3_txt {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        .guding_peng_g {
          width: 860px;
          height: 475px;
          background: url("../assets/img/plantmoxing/new/spk.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin: 10px 0;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
            padding: 20px 20px;
          }
        }
        .guding_peng_g:hover {
          cursor: pointer;
        }
      }
    }
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.contentLine {
  background: #1aa19e;
  position: absolute;
}
.contentLine1 {
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1aa19e);
  animation: animate1 4s linear infinite;
}
.contentLine2 {
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1aa19e);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3 {
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1aa19e);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4 {
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1aa19e);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes animate1 {
  0% {
    left: -50%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}
@keyframes animate3 {
  0% {
    right: -100%;
    height: 3px;
  }

  50%,
  100% {
    height: 2px;
    right: 100%;
  }
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(0.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
